<app-page-title [title]="title()"></app-page-title>
<app-page-loader [load]="pageLoad" [label]="title()" (retry)="init()"></app-page-loader>

<app-kpi-strip [kpis]="kpis" [active]="activeKpi" (activeChange)="setKpi($event)"></app-kpi-strip>

<div class="table-section">
  <div class="filter-bar filter-bar--flush">
    <div class="filter-card">
      <app-search-pill [value]="searchText" placeholder="Folio, locker, guía, código, etiqueta…" (valueChange)="applySearch($event)"></app-search-pill>
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>Periodo</mat-label>
        <mat-date-range-input [rangePicker]="periodPicker">
          <input matStartDate [(ngModel)]="periodStart" placeholder="Inicio" (dateChange)="load()">
          <input matEndDate [(ngModel)]="periodEnd" placeholder="Fin" (dateChange)="load()">
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="periodPicker"></mat-datepicker-toggle>
        <mat-date-range-picker #periodPicker></mat-date-range-picker>
      </mat-form-field>
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>Hospital (origen o destino)</mat-label>
        <mat-select [(value)]="placeFilter" (selectionChange)="load()">
          <mat-option [value]="''">Todos</mat-option>
          @for (p of placeOptions; track p.id) { <mat-option [value]="p.id">{{ p.alias || p.name }}</mat-option> }
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>Estado</mat-label>
        <mat-select [(value)]="statusFilter" (selectionChange)="load()">
          <mat-option [value]="''">Todos</mat-option>
          @for (s of statuses; track s) { <mat-option [value]="s">{{ s }}</mat-option> }
        </mat-select>
      </mat-form-field>
      <mat-button-toggle-group class="view-toggle" [value]="listView.mode" (change)="listView.set($event.value)" [hideSingleSelectionIndicator]="true" aria-label="Vista">
        <mat-button-toggle value="table" matTooltip="Vista de tabla"><mat-icon>table_rows</mat-icon></mat-button-toggle>
        <mat-button-toggle value="cards" matTooltip="Vista de tarjetas"><mat-icon>grid_view</mat-icon></mat-button-toggle>
      </mat-button-toggle-group>
    </div>
    <app-filter-chips [chips]="filterChips" [count]="dataSource.filteredData.length" [total]="dataSource.data.length" noun="traspasos" (remove)="removeChip($event)" (clear)="clearFilters()"></app-filter-chips>
  </div>

  <div class="list-actions">
    <button mat-stroked-button (click)="pageLoad.refresh(load())"><mat-icon>refresh</mat-icon> Actualizar</button>
    <button mat-stroked-button (click)="downloadExcel()" [disabled]="!dataSource.filteredData.length"><mat-icon>download</mat-icon> Descargar Excel</button>
    <button mat-flat-button color="primary" (click)="openForm()"><mat-icon>add</mat-icon> Nuevo traspaso</button>
  </div>

  <mat-paginator [hidden]="listView.mode !== 'table'" [pageSize]="10" [pageSizeOptions]="[5, 10, 25]" showFirstLastButtons></mat-paginator>

  <!-- Acciones por estado (tabla y tarjetas) -->
  <ng-template #rowMenu let-t>
    @if (t.status === 'Borrador') {
      <button mat-menu-item (click)="ship(t)"><mat-icon>send</mat-icon> Enviar</button>
      <button mat-menu-item (click)="openForm(t)"><mat-icon>edit</mat-icon> Editar</button>
    }
    @if (t.status === 'Por recolectar') {
      <button mat-menu-item (click)="dhlMail(t)"><mat-icon>mail</mat-icon> Correo de recolección a DHL</button>
      <button mat-menu-item (click)="guide(t)"><mat-icon>confirmation_number</mat-icon> Capturar guía DHL</button>
    }
    @if (t.status === 'En tránsito') {
      <button mat-menu-item (click)="guide(t)"><mat-icon>confirmation_number</mat-icon> Corregir guía DHL</button>
    }
    @if (t.status === 'Por recolectar' || t.status === 'En tránsito') {
      <button mat-menu-item (click)="receive(t)"><mat-icon>move_to_inbox</mat-icon> Recibir en destino</button>
    }
    <button mat-menu-item (click)="downloadPdf(t)"><mat-icon>picture_as_pdf</mat-icon> Descargar PDF</button>
    @if (t.status === 'Borrador' || t.status === 'Por recolectar') {
      <button mat-menu-item (click)="cancel(t)"><mat-icon>cancel</mat-icon> Cancelar</button>
    }
  </ng-template>

  @if (listView.mode === 'cards') {
    <div class="inv-cards cat-cards">
      @for (t of dataSource.filteredData; track t.id) {
        <div class="cat-card">
          <div class="cat-card__head">
            <span class="cat-card__title">{{ t.folio }}</span>
            <span [class]="statusChip(t.status)">{{ t.status }}</span>
          </div>
          <div class="cat-card__body">
            <div class="cat-card__field"><span class="cat-card__label">Fecha:</span><span class="cat-card__value">{{ fmtDate(t.createdOn) }}</span></div>
            <div class="cat-card__field"><span class="cat-card__label">Origen:</span><span class="cat-card__value">{{ t._origin }}</span></div>
            <div class="cat-card__field"><span class="cat-card__label">Destino:</span><span class="cat-card__value">{{ t._destination }}</span></div>
            <div class="cat-card__field"><span class="cat-card__label">Piezas:</span><span class="cat-card__value">{{ t._pieces }}@if (t._missing) {<span class="flag"> · {{ t._missing }} faltante(s)</span>}</span></div>
            @if (t._request) {<div class="cat-card__field"><span class="cat-card__label">Solicitud:</span><span class="cat-card__value">{{ t._request }}</span></div>}
            @if (!t.sameHospital) {<div class="cat-card__field"><span class="cat-card__label">Guía DHL:</span><span class="cat-card__value">{{ t.dhlGuide || (t.dhlMail?.sentOn ? 'Correo enviado' : '—') }}</span></div>}
          </div>
          <div class="cat-card__actions">
            <button mat-icon-button [matMenuTriggerFor]="cm" matTooltip="Acciones"><mat-icon>more_vert</mat-icon></button>
            <mat-menu #cm="matMenu"><ng-container *ngTemplateOutlet="rowMenu; context: { $implicit: t }"></ng-container></mat-menu>
          </div>
        </div>
      }
      @if (dataSource.filteredData.length === 0) { <p class="inv-cards__empty">Sin traspasos con estos filtros</p> }
    </div>
  }

  <div class="table-container mat-elevation-z2" [hidden]="listView.mode !== 'table'">
    <table mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="folio">
        <th mat-header-cell *matHeaderCellDef>Folio</th>
        <td mat-cell *matCellDef="let t"><code class="folio-badge">{{ t.folio }}</code>@if (t._request) {<span class="sub">{{ t._request }}</span>}</td>
      </ng-container>
      <ng-container matColumnDef="createdOn">
        <th mat-header-cell *matHeaderCellDef>Fecha</th>
        <td mat-cell *matCellDef="let t" class="nowrap">{{ fmtDate(t.createdOn) }}</td>
      </ng-container>
      <ng-container matColumnDef="origin">
        <th mat-header-cell *matHeaderCellDef>Origen</th>
        <td mat-cell *matCellDef="let t">{{ t._origin }}</td>
      </ng-container>
      <ng-container matColumnDef="destination">
        <th mat-header-cell *matHeaderCellDef>Destino</th>
        <td mat-cell *matCellDef="let t">{{ t._destination }}<span class="sub">{{ t.sameHospital ? 'Mismo hospital' : 'Entre hospitales' }}</span></td>
      </ng-container>
      <ng-container matColumnDef="pieces">
        <th mat-header-cell *matHeaderCellDef>Piezas</th>
        <td mat-cell *matCellDef="let t">{{ t._pieces }}@if (t._missing) {<span class="sub flag">{{ t._missing }} faltante(s)</span>}</td>
      </ng-container>
      <ng-container matColumnDef="dhl">
        <th mat-header-cell *matHeaderCellDef>DHL</th>
        <td mat-cell *matCellDef="let t">
          @if (t.sameHospital) { <span class="muted">No aplica</span> }
          @else { {{ t.dhlGuide || '—' }}<span class="sub">{{ t.dhlMail?.sentOn ? 'Correo enviado ' + fmtDate(t.dhlMail.sentOn) : 'Sin correo' }}</span> }
        </td>
      </ng-container>
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Estado</th>
        <td mat-cell *matCellDef="let t"><span [class]="statusChip(t.status)">{{ t.status }}</span></td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let t" class="nowrap">
          @switch (t.status) {
            @case ('Borrador') { <button mat-icon-button color="primary" matTooltip="Enviar" (click)="ship(t)"><mat-icon>send</mat-icon></button> }
            @case ('Por recolectar') { <button mat-icon-button color="primary" matTooltip="Correo de recolección a DHL" (click)="dhlMail(t)"><mat-icon>mail</mat-icon></button> }
            @case ('En tránsito') { <button mat-icon-button color="primary" matTooltip="Recibir en destino" (click)="receive(t)"><mat-icon>move_to_inbox</mat-icon></button> }
          }
          <button mat-icon-button [matMenuTriggerFor]="tm" matTooltip="Más acciones"><mat-icon>more_vert</mat-icon></button>
          <mat-menu #tm="matMenu"><ng-container *ngTemplateOutlet="rowMenu; context: { $implicit: t }"></ng-container></mat-menu>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: columns;" class="table-row"></tr>
      <tr class="no-data-row" *matNoDataRow>
        <td [attr.colspan]="columns.length"><div class="no-data"><mat-icon>swap_horiz</mat-icon><span>Sin traspasos con estos filtros</span></div></td>
      </tr>
    </table>
  </div>
</div>
